const routes = [
  {
    path: '/',
    redirect: '/user-center',
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    meta: { title: '个人中心' },
    component: () =>
      import(/* webpackChunkName:"pages/userCenter" */ '@/pages/userCenter'),
  },
  {
    path: '/user-center/package',
    name: 'UserCenterPackage',
    meta: { title: '购买记录' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/package" */ '@/pages/userCenter/package'
      ),
  },
  {
    path: '/user-center/package/detail',
    name: 'UserCenterPackage',
    meta: { title: '订单详情' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/package" */ '@/pages/userCenter/package/detail'
      ),
  },
  {
    path: '/user-center/refund',
    name: 'UserCenterRefund',
    meta: { title: '申请退款' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/package" */ '@/pages/userCenter/refund'
      ),
  },
  {
    path: '/user-center/battery',
    name: 'UserCenterBattery',
    meta: { title: '我的电池' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/battery" */ '@/pages/userCenter/battery'
      ),
  },
  {
    path: '/user-center/record',
    name: 'Record',
    meta: { title: '换电记录' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/record" */ '@/pages/userCenter/record'
      ),
  },
  {
    path: '/user-center/package/pay-info',
    name: 'UserCenterPackagePayInfo',
    meta: { title: '支付明细' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/package/payInfo" */ '@/pages/userCenter/package/payInfo'
      ),
  },
  {
    path: '/user-center/insurance',
    name: 'UserCenterInsurance',
    meta: { title: '我的保险' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/insurance" */ '@/pages/userCenter/insurance'
      ),
  },
  {
    path: '/user-center/bike',
    name: 'UserCenterBike',
    meta: { title: '我的车辆' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/bike" */ '@/pages/userCenter/bike'
      ),
  },
  {
    path: '/user-center/bike/bind',
    name: 'UserCenterBikeBind',
    meta: { title: '我的车辆' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/bike/bind" */ '@/pages/userCenter/bike/bind'
      ),
  },
  {
    path: '/user-center/bike/info',
    name: 'UserCenterBikeInfo',
    meta: { title: '我的车辆' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/bike/info" */ '@/pages/userCenter/bike/info'
      ),
  },
  {
    path: '/user-center/bike/rebind',
    name: 'UserCenterBikeRebind',
    meta: { title: '重新绑定车辆' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/bike/rebind" */ '@/pages/userCenter/bike/rebind'
      ),
  },
  {
    path: '/user-center/coupon',
    name: 'UserCenterCoupon',
    meta: { title: '我的优惠券' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/coupon" */ '@/pages/userCenter/coupon'
      ),
  },
  {
    path: '/user-center/user-info',
    name: 'UserCenterUserInfo',
    meta: { title: '我的资料' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/userInfo" */ '@/pages/userCenter/userInfo'
      ),
  },
  {
    path: '/user-center/user-info/protocols',
    name: 'UserCenterUserInfoProtocols',
    meta: { title: '协议' },
    component: () =>
      import(
        /* webpackChunkName:"pages/userCenter/userInfo/protocols" */ '@/pages/userCenter/userInfo/protocols'
      ),
  },
  {
    path: '/package',
    name: 'Package',
    meta: { title: '购买套餐' },
    component: () =>
      import(/* webpackChunkName:"pages/package" */ '@/pages/package'),
  },
  {
    path: '/deposit',
    name: 'Deposit',
    meta: { title: '我的押金' },
    component: () =>
      import(/* webpackChunkName:"pages/deposit" */ '@/pages/deposit'),
  },
  {
    path: '/deposit/pay',
    name: 'DepositPay',
    meta: { title: '我的押金' },
    // component: () => import(/* webpackChunkName:"pages/deposit/pay" */'@/pages/deposit/pay'),
    component: () =>
      import(/* webpackChunkName:"pages/deposit" */ '@/pages/deposit'),
  },
  {
    path: '/deposit/refund',
    name: 'DepositRefund',
    meta: { title: '我的押金' },
    // eslint-disable-next-line max-len
    // component: () => import(/* webpackChunkName:"pages/deposit/refund" */'@/pages/deposit/refund'),
    component: () =>
      import(/* webpackChunkName:"pages/deposit" */ '@/pages/deposit'),
  },
  {
    path: '/unlock',
    name: 'Unlock',
    meta: { title: '小哈换电' },
    component: () =>
      import(/* webpackChunkName:"pages/unlock" */ '@/pages/unlock'),
  },
  {
    path: '/unlock-v2',
    name: 'UnlockV2',
    meta: { title: '小哈换电' },
    component: () =>
      import(/* webpackChunkName:"pages/unlockV2" */ '@/pages/unlockV2'),
  },
  {
    path: '/manual_input',
    name: 'manualInput',
    meta: { title: '小哈换电' },
    component: () =>
      import(/* webpackChunkName:"pages/manualInput" */ '@/pages/manualInput'),
  },
  {
    path: '/landing-page',
    name: 'LangingPage',
    meta: { title: '小哈换电' },
    component: () =>
      import(/* webpackChunkName:"pages/langingPage" */ '@/pages/langingPage'),
  },
  {
    path: '/store-list',
    name: 'ShopList',
    meta: {
      title: '门店列表',
    },
    component: () =>
      import(/* webpackChunkName:"pages/shop/list" */ '@/pages/shop/list'),
  },
  {
    path: '/store-detail',
    name: 'ShopDetail',
    meta: {
      title: '门店详情',
    },
    component: () =>
      import(/* webpackChunkName:"pages/shop/detail" */ '@/pages/shop/detail'),
  },
  {
    path: '/rider-certification',
    name: 'RiderCertification',
    meta: { title: '骑手认证' },
    component: () =>
      import(
        /* webpackChunkName:"pages/riderCertification" */ '@/pages/riderCertification'
      ),
  },
  {
    path: '/adapter-web',
    name: 'adapterWeb',
    meta: {
      title: '转接线售卖网点',
    },
    component: () =>
      import(/* webpackChunkName:"pages/adapterWeb" */ '@/pages/adapterWeb'),
  },
  {
    path: '/activity/package-froze',
    name: 'activityPackageFroze',
    meta: { title: '冻结套餐' },
    component: () =>
      import(
        /* webpackChunkName:"pages/adapterWeb" */ '@/pages/activity/packageFroze'
      ),
  },
  {
    path: '/activity/package-froze/record',
    name: 'packageFrozenRecord',
    meta: { title: '冻结记录' },
    component: () =>
      import(
        /* webpackChunkName:"pages/activity/packageFroze/record" */ '@/pages/activity/packageFroze/record'
      ),
  },
  {
    path: '*',
    meta: { title: '小哈换电' },
    component: () => import(/* webpackChunkName:"pages/404" */ '@/pages/404'),
  },
  {
    path: '/before-change-battery',
    name: 'beforeBatteryChange',
    component: () =>
      import(
        /* webpackChunkName:"pages/adapterWeb" */ '@/pages/beforeBatteryChange'
      ),
  },
  {
    path: '/recommend-officer',
    name: 'recommendOfficer',
    meta: { title: '小哈换电' },
    component: () =>
      import(
        /* webpackChunkName:"pages/recommendOfficer" */ '@/pages/recommendOfficer'
      ),
  },
  {
    path: '/activity/inviting-detail',
    name: 'ActivityInvitingDetail',
    meta: { title: '邀请明细' },
    component: () =>
      import(
        /* webpackChunkName:"pages/activity/invitingDetail" */ '@/pages/activity/invitingDetail'
      ),
  },
  {
    path: '/activity/inviting-detail/user-detail',
    name: 'ActivityInvitingDetailUserDetail',
    meta: { title: '累计奖励明细' },
    component: () =>
      import(
        /* webpackChunkName:"pages/activity/invitingDetail" */ '@/pages/activity/invitingDetail/userDetail'
      ),
  },
  {
    path: '/battery-report',
    name: 'BatteryReport',
    mata: { title: '小哈换电' },
    component: () =>
      import(
        /* webpackChunkName:"pages/batteryReport" */ '@/pages/batteryReport'
      ),
  },
  {
    path: '/one-yuan-welfare-card/buy',
    name: 'OneYuanWelfareCardBuy',
    meta: { title: '骑手省钱卡' },
    component: () =>
      import(
        /* webpackChunkName:"pages/oneYuanWelfareCard/buy" */ '@/pages/oneYuanWelfareCard/buy'
      ),
  },
  {
    path: '/one-yuan-welfare-card/mine',
    name: 'OneYuanWelfareCardMine',
    meta: { title: '骑手省钱卡' },
    component: () =>
      import(
        /* webpackChunkName:"pages/oneYuanWelfareCard/mine" */ '@/pages/oneYuanWelfareCard/mine'
      ),
  },
  {
    path: '/lithium-battery-report', // 小哈智电小程序 检测报告页
    name: 'LithiumBatteryReport',
    mata: { title: '小哈智电' },
    component: () =>
      import(
        /* webpackChunkName:"pages/batteryReport" */ '@/pages/lithiumBatteryReport'
      ),
  },
];

export default routes;
